import { CardContainer } from '@apps-common/components/common'
import { SectionTitle } from '@apps-common/components/common/portal-title'
import { ToggleInputSM } from '@apps-common/components/elements/form'
import { VertSpacerMd } from '@apps-common/components/layout'
import { ThemeModeToggle } from '@apps-common/components/theme'
import { AUTH_CLAIMS, Authorization } from '@apps-common/lib'
import { useThemeStore } from '@apps-common/stores'

export const ThemeSettings = () => {
  const { editing, toggleEditing } = useThemeStore()

  return (
    <div className='max-w-[1000px]'>
      <CardContainer bgClasses='bg-secondary md:px-5 md:py-4'>
        <div className='flex items-center justify-between'>
          <SectionTitle classes='text-secondary-content text-left pl-[10px]' text='Theme' />
        </div>
        <VertSpacerMd />
        <div className='bg-secondary-content/5 rounded-[30px] px-2 py-3 pr-3 sm:p-3 sm:pr-4'>
          <Authorization roles={AUTH_CLAIMS.myMonitoringManagementAdmin.roles} scopes={AUTH_CLAIMS.myMonitoringManagementAdmin.scopes}>
            <>
              <ToggleInputSM
                labelLeft='Theme editor'
                containerClassName='!mb-0'
                innerContainerClassName='!m-0 !px-0'
                disabled={false}
                registration={{
                  checked: editing,
                  onChange: (e: any) => toggleEditing()
                }}
              />
              <VertSpacerMd />
            </>
          </Authorization>
          <div className='text-secondary-content flex items-center justify-between pl-[10px]'>
            <p className='text-[0.9em] sm:text-[1em] text-secondary-content'>Theme mode</p>
            <ThemeModeToggle />
          </div>
        </div>
      </CardContainer>
    </div>
  )
}
